
export const dateFormat = function(resultDate,type="normal",reverse=false){
  try {
    if(resultDate==null || resultDate==0){
      return "";
    }
    var date=resultDate;
    if(typeof(resultDate)=="number"){
      date=new Date(resultDate*1000)
    }
    var formatDate="";
    if(type=="normal"){
      formatDate=(date.getDate().toString().length==1?"0"+date.getDate():date.getDate())+"-"+((date.getMonth()+1).toString().length==1?"0"+(date.getMonth()+1):(date.getMonth()+1))+"-"+date.getFullYear();
      if(reverse){
        formatDate=formatDate.split("-")[2]+"-"+formatDate.split("-")[1]+"-"+formatDate.split("-")[0]
      }
    }
    if(type=="full"){
      formatDate=(date.getDate().toString().length==1?"0"+date.getDate():date.getDate())+"-"+((date.getMonth()+1).toString().length==1?"0"+(date.getMonth()+1):(date.getMonth()+1))+"-"+date.getFullYear()+" "+(date.getHours().toString().length==1?"0"+date.getHours():date.getHours())+":"+(date.getMinutes().toString().length==1?"0"+date.getMinutes():date.getMinutes());
    }
    return formatDate;
  } catch (error) {
    return resultDate;
  }
}